import React from 'react';
import { Container, Typography } from '@mui/material';

const NotFoundComponent = () => {
  return React.createElement(Container, null, 
    React.createElement(Typography, { variant: 'h4', gutterBottom: true }, '404 - Page Not Found')
  );
};

export default NotFoundComponent;
